import { useMutation } from "@apollo/client";
import { useState } from "react";
import Button from 'react-bootstrap/Button';
import { ADD_USER } from "./queries";
import { useNhostClient } from '@nhost/react';

import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { IoPersonAddSharp } from "react-icons/io5";

interface CreateUsersProps {
  onUserCreated: () => void;
}

export default function CreateUsers({ onUserCreated }: CreateUsersProps) {
  const nhost = useNhostClient();

  // États du formulaire
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("user");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [open, setOpen] = useState(false);

  // Mutation GraphQL pour insérer un utilisateur sans mot de passe
  const [addUser] = useMutation(ADD_USER);

  // Gestion de l'ouverture/fermeture de la modale
  const handleClose = () => setOpen(false);
  const handleShow = () => setOpen(true);

  // Création de l'utilisateur et envoi du lien de réinitialisation
  const handleCreateUser = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setShowSuccessMessage(false);
    setError(null);

    try {
      const normalizedEmail = email.trim().toLowerCase();

      // Étape 1 : Appel de la mutation pour créer l'utilisateur
      await addUser({
        variables: {
          email: normalizedEmail,
          role,
        },
      });

      // Étape 2 : Envoi d'un lien de réinitialisation de mot de passe
      await nhost.auth.resetPassword({ email });

      setLoading(false);
      setEmail("");
      setShowSuccessMessage(true);

      // Fermeture automatique après succès
      setTimeout(() => {
        setShowSuccessMessage(false);
        setOpen(false);
        onUserCreated();
      }, 1000);
    } catch (err) {
      setLoading(false);
      setError(
        err instanceof Error ? err.message : "Une erreur inconnue est survenue"
      );
    }
  };

  return (
    <>
      <Button
        onClick={handleShow}
        className="d-flex justify-content-center custom-gradient-btn create-button"
      >
        <IoPersonAddSharp />
      </Button>

      <Modal show={open} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Ajouter un utilisateur</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && (
            <p className="bg-light text-danger p-3 rounded mb-4 small">
              {error}
            </p>
          )}
          {showSuccessMessage && (
            <p className="bg-success bg-opacity-10 text-success p-3 rounded mb-4 small">
              Utilisateur créé avec succès !
            </p>
          )}

          <Form onSubmit={handleCreateUser} className="space-y-4">
            <Form.Group className="mb-3" controlId="inputEmail">
              <Form.Control
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="selectRole">
              <Form.Select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                required
              >
                <option value="admin">Administrateur</option>
                <option value="user">Utilisateur</option>
                
              </Form.Select>
            </Form.Group>

            <Button
              type="submit"
              disabled={loading}
              className="custom-gradient-btn w-100 fw-medium rounded text-white px-4 py-2"
            >
              {loading ? "Création en cours..." : "Créer l'utilisateur"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
